import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=5caa1936&scoped=true&lang=html"
var script = {}
import style0 from "./Spinner.vue?vue&type=style&index=0&id=5caa1936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caa1936",
  null
  
)

export default component.exports